export default {
  folders: [],
  folder: null,
};
